import { ScheduledSectionsQuery } from '../../queries/scheduled_sections_query';
import { ISection } from '../../../../interfaces/scheduler_interfaces';
import { SectionInfoServant, IFormattedSectionTime } from '../../../sections/servants/section_info_servant';
import { ScheduledSectionServant } from '../../servants/scheduled_section_servant';
import { ScheduledSectionTileServant } from '../../servants/scheduled_section_tile_servant';
import * as _4 from 'lodash4';

class LinkedSectionMessage {
  private section: ISection;
  private linkedSectionMessage: string;
  private hasRegisteredLinkedSections: boolean;
  constructor(
    private ngScheduledSectionServant: ScheduledSectionServant,
    private ngScheduledSectionsQuery: ScheduledSectionsQuery,
    private ngSectionInfoServant: SectionInfoServant
  ) {}
  initialize() {
    const registeredLinkedSections = this.ngScheduledSectionServant.getRegisteredLinkedSections(
      this.section.id,
      this.ngScheduledSectionsQuery.result.list
    );
    this.hasRegisteredLinkedSections = _4.size(registeredLinkedSections) > 0;
    const plural = _4.size(registeredLinkedSections) > 1 ? `courses` : `course`;
    const linkedSections = _4.map(
      registeredLinkedSections,
      (section) =>
        `${section._course.cd} ${section._course.title} (${this.ngSectionInfoServant.getSectionLabel(section)})`
    );
    this.linkedSectionMessage = `This course is linked to the following ${plural}: ${linkedSections.join(', ')}`;
  }
  $onInit() {
    this.initialize();
  }
  $onChanges() {
    this.initialize();
  }
}

class LinkedSectionMessageComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      section: '<'
    };
    this.controller = LinkedSectionMessage;
    this.templateUrl =
      'capability-ng-scheduler/src/views/course_scheduler/components/linked_section_message/linked_section_message.html';
  }
}
angular.module('capability-ng-scheduler').component('linkedSectionMessage', new LinkedSectionMessageComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/components/linked_section_message/linked_section_message.ts